import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import { TouchableWithoutFeedback, View } from "react-native";

export default class CustomTouchableWithoutFeedback extends React.Component {
  // static contextType = StyleContext;

  constructor(props) {
    super(props);
    let defaultHaptics = "medium";
    let hapticFeedback = props.haptics == true ? defaultHaptics : props.haptics;
    this.state = {
      hapticFeedback,
      mouseDownAt: null,
      mouseUpAt: null,
    };
  }

  render() {
    return (
      <TouchableWithoutFeedback
        {...this.props}
        onPress={ENV.WEB ? undefined : this.props.onPress}
        onLongPress={ENV.WEB ? undefined : this.props.onLongPress}
        onMouseDown={ENV.WEB ? this.handleMouseDown : undefined}
        onMouseUp={ENV.WEB ? this.handleMouseUp : undefined}
        onMouseLeave={ENV.WEB ? this.cancelPress : undefined}
      >
        {Array.isArray(this.props.children) ||
        !React.isValidElement(this.props.children) ? (
          // the RN component does React.Children.only — normalize arrays
          // so a multi-child caller can't crash the page
          <View>{this.props.children}</View>
        ) : (
          this.props.children
        )}
      </TouchableWithoutFeedback>
    );
  }

  handlePress = (e) => {
    let { hapticFeedback } = this.state;
    if (!!hapticFeedback) {
      haptics[hapticFeedback]();
    }
    this.props.onPress(e);
  };

  handleMouseDown = (e) => {
    if (this.props.onMouseDown) this.props.onMouseDown(e);

    if (this.longPressListener) clearTimeout(this.longPressListener);

    this.mouseDownEvent = e;
    this.mouseDownAt = new Date().getTime();
    this.mouseUpAt = null;

    this.longPressListener = setTimeout(() => {
      if (!!this.mouseDownAt && !this.mouseUpAt) {
        this.mouseUpAt = null;
        this.mouseDownAt = null;
        this.props.onLongPress && this.props.onLongPress(e);
      }
    }, 500);
  };

  handleMouseUp = async (e) => {
    this.mouseUpAt = new Date().getTime();
    if (!!this.mouseDownAt) {
      if (this.mouseUpAt - this.mouseDownAt >= 500) {
        // this.props.onLongPress && this.props.onLongPress(e);
      } else {
        this.props.onPress && this.handlePress(this.mouseDownEvent);
      }
    }
    this.mouseDownAt = null;
  };

  cancelPress = () => {
    if (this.longPressListener) clearTimeout(this.longPressListener);
    this.mouseDownAt = null;
    this.mouseUpAt = null;
  };
}
